import React,{useState,useEffect} from 'react';
import PropTypes from 'prop-types';
import { withStyles,makeStyles, useTheme } from '@material-ui/core/styles';

import FirstPageIcon from '@material-ui/icons/FirstPage';
import KeyboardArrowLeft from '@material-ui/icons/KeyboardArrowLeft';
import KeyboardArrowRight from '@material-ui/icons/KeyboardArrowRight';
import {LastPage,AllInclusive,Add,MoreVert,Edit,Delete,Done,Block,Visibility,Gavel,FilterList, FormatListNumbered,ConfirmationNumber,HourglassEmpty,Check,LocalAtm} from '@material-ui/icons';

import { withLocalize,Translate } from "react-localize-redux";

import {
  TableRow ,
  TablePagination,
  TableFooter,
  TableContainer,
  TableCell,
  TableBody,
  Table ,
  TableHead,
  Button,
  IconButton,
  Paper,
  Typography,
  Toolbar,
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  AppBar,
  TextField,
  FormControlLabel,
  Checkbox,
  Container ,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Menu,
  TextareaAutosize,
  Chip,
  LinearProgress,
  CircularProgress,
  FormHelperText,
  List,
  ListItem,
  ListItemText,
  ListItemAvatar,
  Avatar,
  Grid,
  Link,
  ListItemIcon,
  ListItemSecondaryAction,
  Badge
} from "@material-ui/core";

import Format from "date-fns/format";

import { MuiPickersUtilsProvider, DatePicker } from "@material-ui/pickers";

import {useHistory } from "react-router-dom";

import MUIDataTable from "mui-datatables";

import { useSnackbar } from 'notistack';

import {TransportService,ReportingService,AdminService,FinanceService} from "./../../utils/web_config_2";


import UserInfo from "./login_info";

import DateFnsUtils from "@date-io/date-fns";

import axios from 'axios';

import Chart from 'react-apexcharts'

import Skeleton from '@material-ui/lab/Skeleton';
import Autocomplete from '@material-ui/lab/Autocomplete';
import { getDate } from 'date-fns';

import Transfer from "../../assets/svg/transfer.svg";
import CancelTransfer from "../../assets/svg/canceltransfer.svg";
import Bus from "../../assets/svg/bus.svg";

import Popover from '@material-ui/core/Popover';



const useStyles1 = makeStyles((theme) => ({
  root: {
    flexShrink: 0,
    flexFlow:1,
    [theme.breakpoints.up('sm')]:{
      marginLeft:250,
    }
  },
  btn:{
    textTransform:"capitalize",

  },
  formTitle:{
    flexGrow:1,
},
paper: {
    padding: theme.spacing(2),
    textAlign: 'center',
    color: theme.palette.text.secondary,
    
    elevation:0
  },paper1:{
    height:300
  }
}));


 function ReportSettlement() {
  const classes = useStyles1();

  const [operatorData, setOperatorData] = useState({});

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [reportsMessage,setReportsMessage]=useState("Loading...");
  const [reportTitle,setReportTitle]=useState("Settlement batches report");

  // pop over for settlement filter
  const [anchorEl, setAnchorEl]=useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const open = Boolean(anchorEl);
  const id = open ? 'simple-popover' : undefined;

  const [startDate,setStartDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});
  const [endDate,setEndDate]=useState({value:Format(new Date(), ["yyyy-MM-dd",]),error:""});


  const history = useHistory();

 
 const options = {textLabels: {
  body: {
    noMatch: reportsMessage
  },
},
   filterType: 'checkbox',
   download:true,
   responsive:"standard",
   selectableRows:false,
   rowsPerPage: 10,
   elevation:0,
 };

//  settlement table 

const columns = [
    {
      name: "account_name",
      label: "Account Name",
      options: {
       filter: true,
       sort: true,
      }
     }
    ,
    {
     name: "batch_number",
     label: "Batch Number",
     options: {
      filter: true,
      sort: true,
      customBodyRender: (value, tableMeta, updateValue) => {
        return (<Typography style={{color:"red"}}><Link onClick={()=>{
        var obj=reports.find((o)=>o['batch_number']==value);

       
     
        setValidators(obj['device_data']);
        setValidatorDialog(true);

        }} href="#">{value}</Link>

        </Typography>)
      }
     }
    }, {
      name: "total_number",
      label: "Total number",
      options: {
       filter: true,
       sort: true,
      }
     }, 
     
    //  {
    //   name: "total_amount",
    //   label: "Total amount",
    //   options: {
    //    filter: true,
    //    sort: true,
    //   }
    //  },
    //   {
    //   name: "commission_amount",
    //   label: "Commission",
    //   options: {
    //    filter: true,
    //    sort: true,
    //   }
    //  }, 
     {
      name: "operator_amount",
      label: "Operator Amount",
      options: {
       filter: true,
       sort: true,
      }
     }, {
      name: "operator_bank_account",
      label: "Operator bank account",
      options: {
       filter: true,
       sort: true,
       display:false
      }
     }, {
      name: "trust_bank_account",
      label: "Trust bank account",
      options: {
       filter: true,
       sort: true,
       display:false
      }
     }, {
      name: "commission_bank_account",
      label: "Commission bank account",
      options: {
       filter: true,
       sort: true,
       display:false
      }
     }, {
      name: "settlement_status",
      label: "Settlement status",
      options: {
       filter: true,
       sort: true,
      }
     }, {
      name: "transfer_status",
      label: "Transfer status",
      options: {
       filter: true,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
                   if(value=="COMPLETED"){
                    return (
                      <Chip
                      color="primary"
                      label={value}
                      variant="outlined"
                      onDelete={()=>{}}
                      deleteIcon={<Done />}
                    ></Chip>
                        
                    );
                   }else{
                    return (
                      <Chip
                      color="secondary"
                      label={value}
                      onDelete={()=>{}}
                      deleteIcon={<Block />}
                    ></Chip>
                        
                    );
                   }
                  
                }
           
      }
     }, {
      name: "created_at",
      label: "Created at",
      options: {
       filter: true,
       sort: true,
      }
     }, {
      name: "updated_at",
      label: "Updated at",
      options: {
       filter: true,
       sort: true,
       display:false
      }
     }, {
      name: "transfer_status",
      label: "Message",
      options: {
       filter: true,
       display:false,
       sort: true,
       customBodyRender: (value, tableMeta, updateValue) => {
         if(value="SUCCESS"){
          return (<Typography color="primary">
          {value}
                   </Typography>)
         }else{
          return (<Typography style={{color:"red"}}>
          {value}
                   </Typography>)
         }
        
       }
      }
     }
    //  ,
    // {
    //  name: "amount",
    //  label: "Amount",
    //  options: {
    //   filter: true,
    //   sort: true,
    //   customBodyRender: (value, tableMeta, updateValue) => {
    //     return(
    //         <font>{value} FRW</font>
    //     )  
    //  }
    //  }
    // },
   
      //  {
      //      name: "created_at",
      //      label: "Created at",
      //      options: {
      //       filter: true,
      //       sort: true,
      //      }
      //     },
          // {
          //   name: "transaction_status",
          //   label: "Transaction status",
          //    options: {
          //        filter: true,
          //        sort: true,
          //        customBodyRender: (value, tableMeta, updateValue) => {
          //            if(value=="COMPLETED"){
          //             return (
          //               <Chip
          //               color="primary"
          //               label={value}
          //               variant="outlined"
          //               onDelete={()=>{}}
          //               deleteIcon={<Done />}
          //             ></Chip>
                          
          //             );
          //            }else{
          //             return (
          //               <Chip
          //               color="secondary"
          //               label={value}
          //               onDelete={()=>{}}
          //               deleteIcon={<Block />}
          //             ></Chip>
                          
          //             );
          //            }
                    
          //         }
          //    }
          //   }
   ];
  

 useEffect(()=>{

  var data = {};
  const data1 = localStorage.getItem("nx_op");
  if (data1 != null) {
    data = JSON.parse(data1);
  }

  setOperatorData(data);
  axios.defaults.baseURL = new FinanceService().BASE_URL;

  get_settlement_report(data.token,getDate(),getDate());

 },[]);


 const getDate=()=>{
  return Format(new Date(), ["yyyy-MM-dd",]);
}


 const [amounts,setAmounts]=useState([]);
 const [labels,setLabels]=useState([]); 


//  settlement performance 


 const settlement_performance= 
{options:{
    series: amounts,
    chart: {
    width: 380,
    type: 'pie',
  },
  
  labels: labels,
  legend: {
    position: 'right',
    itemMargin:{
        horizontal:0
    }
  },
  responsive: [{
    breakpoint: 480,
    options: {
      chart: {
        width: 280,
        height:280
      },
      legend: {
        position: 'right'
      }
    }
  }]
  }
}

// chart settlement 


const [settlementChart,setSettlementChart]=useState({    
  // series:[completed,failed],
  series:[],
  options: {
    chart: {
      width:"100%",
      type: 'donut',
    },
    colors:['#1892F8', '#E91E63'],
    labels: ["Completed","Failed"],
    responsive: [{
      breakpoint: 480,
      options: {
        chart: {
          width: "100%"
        },
        legend: {
          position: 'right'
        }
      }
    }]
  },
});


//   get settlement report 

const [failed,setFailed]=useState(0);
const [completed,setCompleted]=useState(0);

const [totalAmount,setTotalAmount]=useState(0);
const [totalFailAmount,setTotalFailAmount]=useState(0);



const [reportLoad,setReportLoad]=useState(false);
const [reports,setReports]=useState([]);
const get_settlement_report=(token,start_date,end_date)=>{

setTotalAmount(0);
setTotalFailAmount(0);
setFailed(0);
setCompleted(0);

setReports([]);
setReportLoad(true);
axios.defaults.baseURL = new FinanceService().BASE_URL;
const reportInstance = axios.create(new FinanceService().setHeaders(token));
  reportInstance.get('/api/v1/getSettlementBatches?organization_id=' + new UserInfo().ORG_ID + "&start_date=" + start_date + "&end_date=" + end_date +"&page=0&per_page=100000")
.then(res=>{
    var objs=res.data.data;
    console.log("=====  report ooo =====",objs);
    if(objs.length==0){
        setReportsMessage("No settlement available today");
    }else{
      var c=0;
      var f=0;

      let cc=0;
      let ff=0;
      objs.map((o)=>{
        if(o['transfer_status']=="COMPLETED"){
          cc+=parseInt(o['total_amount']);
          c++;
        }else if(o['transfer_status']=="FAILED"){
          ff+=parseInt(o['total_amount']);
          f++;
        }

        o['total_amount']=formatMoney(o['total_amount'],0);
        o['operator_amount']=formatMoney(o['operator_amount'],0);
        o['commission_amount']=formatMoney(o['commission_amount'],0);

       
      });
   
      setTotalAmount(cc);
      setTotalFailAmount(ff);
      setFailed(f);
      setCompleted(c);

      setSettlementChart({    
        // series:[completed,failed],
        series:[c,f],
        options: {
          chart: {
            type: 'donut',
          },
          colors:['#1892F8', '#E91E63'],
          labels: ["Completed","Failed"],
          responsive: [{
            breakpoint: 480,
            options: {
              chart: {
                width: "100%"
              },
              legend: {
                position: 'right'
              }
            }
          }]
        },
      });

        setReports(objs);
    }
   
    setReportLoad(false);

})
.catch(err=>{
    
    setReportLoad(false);
    if(err.message){
      setReportsMessage(err.message);
      enqueueSnackbar(err.message,
        { 
          variant: 'error'
      });
    }

    if(err.response){
      setReportsMessage(err.response.data.message);
      enqueueSnackbar(err.response.data.message,
        { 
          variant: 'error'
      });
    }
});

}






  // format money 
  function formatMoney(amount, decimalCount = 2, decimal = ".", thousands = ",") {
    try {
      decimalCount = Math.abs(decimalCount);
      decimalCount = isNaN(decimalCount) ? 2 : decimalCount;
  
      const negativeSign = amount < 0 ? "-" : "";
  
      let i = parseInt(amount = Math.abs(Number(amount) || 0).toFixed(decimalCount)).toString();
      let j = (i.length > 3) ? i.length % 3 : 0;
  
      return negativeSign + (j ? i.substr(0, j) + thousands : '') + i.substr(j).replace(/(\d{3})(?=\d)/g, "$1" + thousands) + (decimalCount ? decimal + Math.abs(amount - i).toFixed(decimalCount).slice(2) : "");
    } catch (e) {
      console.log(e)
    }
  };


  const [validatorDialog,setValidatorDialog]=useState(false);
  const [validators,setValidators]=useState([]);



  return (
<MuiPickersUtilsProvider utils={DateFnsUtils}>
<div className={classes.root}>
<Box display="flex">
 
<Box display="flex" alignItems="center" mt={2} className={classes.formTitle}>
 
<Box mr={1}><LocalAtm fontSize="large" color="primary"/></Box> <Typography style={{flexGrow:1}}  variant="h5" color="default"><b>Settlement Report</b></Typography>
 
<Button startIcon={<FilterList/>} style={{textTransform:"capitalize"}} onClick={handleClick} variant="outlined" color="primary">Filter</Button>

<Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
      >
       <Box p={4}>
       <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            autoOk
                            label="Start date"
                            value={startDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen1: ", Format(v, ["yyyy-MM-dd",]));
                                setStartDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                                get_settlement_report(operatorData.token,Format(v, ["yyyy-MM-dd",]),endDate.value);
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
        
          </Box>
          <Box mt={1}>
                          <DatePicker
                            fullWidth
                            disableToolbar
                            variant="inline"
                            format="yyyy-MM-dd"
                            margin="dense"
                            autoOk
                            label="End date"
                            value={endDate.value}
                            inputVariant="outlined"
                            onChange={(v)=>{
                                console.log("choosen2: ",v);
                                setEndDate({value:Format(v, ["yyyy-MM-dd",]),error:""});
                                get_settlement_report(operatorData.token,startDate.value,Format(v, ["yyyy-MM-dd",]));
                            }}
                            InputProps={{
                              disableUnderline: true,
                              style: { paddingRight: 0 },
                            }}
                          />
            </Box>
       </Box>
      </Popover>

</Box>

</Box>


<Box mt={2}>
    <Grid container spacing={2}>

 
<Grid item xs={12} md={5} >
       <Grid container spacing={1}>
         {/* total tickets  */}
         <Grid item xs={12} sm={12} md={12} lg={12}>
         <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Completed Transfer</Typography></Box>
  <Box mt={2}><Typography variant="h5" className={classes.title}>{completed}</Typography></Box>
  <Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(totalAmount,0)} </Typography></Box>
           
           
          </Grid>

          <Grid item xs={6} md={6}>
            <img src={Transfer} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
         </Grid>
         {/* total amount  */}
         <Grid item xs={12} sm={12} md={12} lg={12}>
         <Paper className={classes.paper} elevation={0}>
            <Grid container>
          <Grid item xs={6} md={6}>
            <Box><Typography variant="h8" className={classes.title}>Failed Transfer</Typography></Box>
<Box mt={2}><Typography variant="h5" className={classes.title}>{failed}</Typography></Box>
<Box mt={2}><Typography variant="h6" className={classes.title}>{formatMoney(totalFailAmount,0)} </Typography></Box> 
          </Grid>
          <Grid item xs={6} md={6}>
            <img src={CancelTransfer} width="70px" height="70px"/>
          </Grid>

          </Grid>
          </Paper>
         </Grid>
       </Grid>
           

          </Grid>



{/* settlement  chart */}


<Grid item xs={12} md={7} >

       <Paper className={classes.paper1} elevation={0}>  
<Chart options={settlementChart.options} series={settlementChart.series} type="pie" width={350} height={220} />
</Paper> 
          </Grid>



        <Grid item md={12} lg={12} sm={12} xs={12}>
        {reportLoad&&<LinearProgress/>}
<MUIDataTable
  title={reportTitle}
  data={reports}
  columns={columns}
  options={options}
/>
</Grid>

    </Grid>

</Box> 

 </div>



 {/* validators  */}



<Dialog
    maxWidth="sm"
    fullWidth
        open={validatorDialog}
        onClose={()=>{
          setValidatorDialog(false);
        }}
        aria-labelledby="Validator"
        aria-describedby="Validator"
      >
        <DialogTitle id="Validator">{"Buses"}</DialogTitle>
        <DialogContent>
          <DialogContentText >
          <Box>
            
          <List component="nav" aria-label="main mailbox folders">
            { validators.map((o)=>{
              var v="";
              var count=0;
              var amount=0;
                for (const [key, value] of Object.entries(o)) {
                  // console.log(key, value);
                  v=key;
                  count=value['total_count'];
                  amount=value['total_amount'];
              }
              return(
          <ListItem >
          <ListItemIcon>
            <img src={Bus} width="50px" height="50px"/>
          </ListItemIcon>
          <ListItemText primary={<b>{v}</b>} secondary={formatMoney(amount)+ " RWF"}  />
          <ListItemSecondaryAction>
                  <Badge
                badgeContent={count}
                showZero={false}
                max={100000000}
                variant="standard"
                color="secondary"
              /> 
                  </ListItemSecondaryAction>
        </ListItem>
              );
            })}
      </List>
          </Box>
         </DialogContentText>
         </DialogContent>

         <DialogActions>
         
          <Button onClick={()=>{
              setValidatorDialog(false);
          }} color="secondary" className={classes.btn}>
            <Typography>Close</Typography>
          </Button>


         


        </DialogActions>
         </Dialog>



 </MuiPickersUtilsProvider>
  );
}

export default withLocalize(ReportSettlement);